import { ImportBase } from "./import.service";
import { Field } from "../fields/field.model";
import { ImportIsoxml } from "./importISOXML.service";

export interface FileParsingError {
    filename: string,
    errorMessage: string
}

export interface ImportState {
    importHandler: ImportBase;
    importedFields: ImportField[],
    isLoaded: boolean,

    isImportDialogOpen: boolean,
    fileParsingErrors: FileParsingError[]
}

export const initialImportState: ImportState = {
    importHandler: new ImportIsoxml(),
    importedFields: [],
    isLoaded: false,
    isImportDialogOpen: false,
    fileParsingErrors: []
}


export interface ImportField {
    importKey: string,
    field: Field,
    selected: boolean,
    isImported: boolean,
    hasError: boolean,
    errorMessage?: string
}

